export default function getEmployerBankAccounts(employer) {
	const hostname = window.location.hostname
	const isProd = hostname === "my.salusion.com" || hostname === "my.salusion-preprod.com"

	const billingAccount = employer?.employerAccount?.billingAccount || ""
	const reimbursementAccount = employer?.employerAccount?.employeeReimbursementAccount

	// if (!isProd && billingAccount?.id) {
	// 	billingAccount.routingNumber = 123456
	// 	billingAccount.accountNumber = 123456

	// 	let accountType = billingAccount?.accountType
	// 	billingAccount.accountType = accountType.charAt(0).toUpperCase() + accountType.slice(1)
	// }

	// if (!isProd && reimbursementAccount?.id) {
	// 	reimbursementAccount.routingNumber = 123456
	// 	reimbursementAccount.accountNumber = 123456

	// 	let accountType = reimbursementAccount?.accountType || ""
	// 	reimbursementAccount.accountType = accountType.charAt(0).toUpperCase() + accountType.slice(1)
	// }

	return { billingAccount, reimbursementAccount }
}
